export enum PatientActionEvents {
  addTaskActionMenuButtonClicked = 'Add Task Action Menu Button Clicked',
  orderLabOptionActionMenuButtonClicked = 'Order Lab Action Menu Button Clicked',
  scheduleAppointmentsActionMenuV2ButtonClicked = 'Schedule Appointments Action Menu V2 Button Clicked',
  uploadDocumentActionMenuButtonClicked = 'Upload Document Action Menu Button Clicked',
  generatePatientReportActionMenuButtonClicked = 'Generate Patient Report Action Menu Button Clicked',
  generatePatientReportTypeSelected = 'Generate Patient Report Type Selected',
  generatePatientReportWarningSurfaced = 'Generate Patient Report Warning Surfaced',
  generatePatientReportModalDismissed = 'Generate Patient Report Modal Dismissed',
  generatePatientReportCreateClicked = 'Generate Patient Report Create Clicked',
  generatePatientReportCreateSucceeded = 'Generate Patient Report Create Succeeded',
  generatePatientReportCreateFailed = 'Generate Patient Report Create Failed',
}
